// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Staff_pageHeader__33pEo"};